import React, { useEffect, useState } from "react";
import { Flame, Check } from "lucide-react";
import { recordDailyActivity, getStreakData } from "../lib/streak";

export const DailyStreakCard = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    recordDailyActivity();
    setData(getStreakData());
  }, []);

  if (!data) return null;
  return (
    <div
      className="rounded-2xl border-2 border-orange-400/60 bg-gradient-to-r from-orange-950/40 via-slate-900 to-slate-900 px-5 py-4 flex flex-col sm:flex-row items-center gap-4"
      data-testid="daily-streak-card"
    >
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-full bg-orange-500/20 border border-orange-400/60 flex items-center justify-center flex-shrink-0">
          <Flame className="w-6 h-6 text-orange-400" />
        </div>
        <div>
          <p className="text-white font-black text-lg leading-tight" data-testid="streak-count">
            {data.current}-day streak
          </p>
          <p className="text-white/55 text-xs">
            Longest: {data.longest} · {data.totalDays} total days showing up
          </p>
        </div>
      </div>
      <div className="flex gap-1.5 sm:ml-auto" data-testid="streak-week">
        {data.week.map((day, i) => (
          <div key={day.date} className="flex flex-col items-center gap-1" data-testid={`streak-day-${i}`}>
            <div
              className={`w-8 h-8 rounded-lg flex items-center justify-center border ${
                day.active
                  ? "bg-orange-500 border-orange-400 text-slate-950"
                  : "bg-white/5 border-white/15 text-white/25"
              } ${day.isToday ? "ring-2 ring-orange-300/70" : ""}`}
            >
              {day.active ? <Check className="w-4 h-4" strokeWidth={3} /> : null}
            </div>
            <span className={`text-[9px] font-bold ${day.active ? "text-orange-300" : "text-white/35"}`}>{day.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
